import React from 'react';

import { Attribution } from '@confluence/error-boundary/entry-points/Attribution.ts';
import { ErrorBoundary } from '@confluence/error-boundary/entry-points/ErrorBoundary.ts';
import { isStableUIEnabledForTests } from '@confluence/e2e-url-override/entry-points/isStableUIEnabledForTests.ts';
import { EndOfTrialModalContainerWithErrorBoundaryLoadable } from '@confluence/experiment-ai-in-editor-eot/entry-points/end-of-trial-modal.ts';
import { UpgradeFreePoolExperimentModalPostUpgradeModalLoadable } from '@confluence/experiment-upgrade-free-pool-target/entry-points/post-upgrade-modal.tsx';
import { UpgradeFreePoolExperimentModalPreUpgradeModalLoadable } from '@confluence/experiment-upgrade-free-pool-target/entry-points/pre-upgrade-modal.tsx';
import { fg } from '@confluence/feature-gating';
import { CrossJoinNudgesWithFlags } from '@confluence/cross-join-nudges';

export const GrowthComponentsLoader = () => {
	if (isStableUIEnabledForTests()) {
		return null;
	}

	return (
		<>
			<ErrorBoundary
				attribution={Attribution.GROWTH_PUMA}
				attributes={{
					errorBoundaryId: 'GlobalComponents-GrowthPuma',
				}}
			>
				<CrossJoinNudgesWithFlags />
			</ErrorBoundary>

			<ErrorBoundary
				attribution={Attribution.GROWTH_LUNA}
				attributes={{
					errorBoundaryId: 'GlobalComponents-GrowthArtemis',
				}}
			>
				{fg('twcg-206_confluence_upgrade_permanent_free_fg') && (
					<>
						<UpgradeFreePoolExperimentModalPreUpgradeModalLoadable />
						<UpgradeFreePoolExperimentModalPostUpgradeModalLoadable />
					</>
				)}
				{fg('twcg-530_confluence_ai_in_editor_eot_gate') && (
					<EndOfTrialModalContainerWithErrorBoundaryLoadable />
				)}
			</ErrorBoundary>
		</>
	);
};
